import { ButtonProgressComponent } from './lib/button-progress/button-progress.component';
import { CloseButtonComponent } from './lib/close-button/close-button.component';
import { ToolbarGroupDirective } from './lib/toolbar/toolbar-group.directive';
import { ToolbarDirective } from './lib/toolbar/toolbar.directive';
import { UiBadgeTextDirective } from './lib/ui-badge/ui-badge-text.directive';
import { UiBadgeComponent } from './lib/ui-badge/ui-badge.component';

export * from './lib/button-progress/button-progress-state';

export const UI_BUTTONS_TOOLBAR = [ToolbarDirective, ToolbarGroupDirective] as const;

/**
 * Utility array that contains all `@mri-platform/ui-buttons` related components and directives
 */
export const UI_BUTTONS = [
  ButtonProgressComponent,
  CloseButtonComponent,
  ...UI_BUTTONS_TOOLBAR,
  UiBadgeComponent,
  UiBadgeTextDirective
] as const;

export {
  ButtonProgressComponent,
  CloseButtonComponent,
  ToolbarDirective,
  ToolbarGroupDirective,
  UiBadgeComponent,
  UiBadgeTextDirective
};
